export enum GeneialFieldVersionTypeEnum {
  text = "text",
  email = "email",
  radio = "radio",
  checkbox = "checkbox",
  descriptive = "descriptive",
  calc = "calc",
  calc_on_read = "calc_on_read",
  calc_on_write = "calc_on_write",
  number = "number",
  dropdown = "dropdown",
  notes = "notes",
  yesno = "yesno",
  file = "file",
}

export enum GeneialFieldVersionStatusEnum {
  draft = "draft",
  review = "review",
  active = "active",
  archive = "archive",
}

export interface IGeneialFieldVersion {
  id: number;
  field_key: string;
  field_title: string;
  field_description?: string;
  help_text?: string;
  geneial_field_id: string;
  version_major: number;
  field_type: GeneialFieldVersionTypeEnum;
  status: GeneialFieldVersionStatusEnum;
  calculation?: string;
  validation?: string;
  mapping_logic?: any[];
  code_mappings?: any[];
  time_created: string;
  time_updated?: string;
  version_minor?: number;
  version_patch?: number;
  display_name?: string;
  note?: string;
  is_excluded?: boolean;
  options?: any[];
  is_phi?: boolean;
  is_required?: boolean;
  fields?: IGeneialFieldVersion[];
}
